import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  container: {
    maxWidth: '800px',
  },
});
